"use client";
import { jsx as _jsx } from "react/jsx-runtime";
// import hooks
import { useMediaQuery } from "@mui/material";
import { MobileSteps } from "../../../feature-discovery/sdb-ui/mobile.steps.js";
import { DesktopSteps } from "../../../feature-discovery/sdb-ui/desktop.steps.js";
import { observer } from "../../../client-store/index.js";
import createSteps from "../../../feature-discovery/utils/createSteps/createSteps.util.js";
import { SINGLE } from "../../../constants/numbers.consts.js";
import FeatureDiscoveryOrganism from "../../../components/organisms/FeatureDiscovery/FeatureDiscovery.organism.js";
import featureDiscoveryStore from "../../../components/templates/FeatureDiscovery/FeatureDiscovery.store.js";
export const FeatureDiscoveryClientOrganism = observer(({ options }) => {
    const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("expanded"));
    const baseSteps = isSmallDevice ? MobileSteps : DesktopSteps;
    const steps = options
        ? createSteps(baseSteps, options)
        : createSteps(baseSteps);
    return (_jsx(FeatureDiscoveryOrganism, { open: featureDiscoveryStore.open, onFinish: featureDiscoveryStore.stop, viewed: featureDiscoveryStore.viewed, setViewed: featureDiscoveryStore.setViewed, featureDiscoveryName: featureDiscoveryStore.tourId, steps: steps, tourVersion: "1", text: options?.text ?? {
            previous: "Vorige",
            next: "Volgende",
            done: "Klaar",
            pagination: ({ currentStep, totalSteps }) => `${currentStep + SINGLE} van ${totalSteps}`,
        } }));
});
export default FeatureDiscoveryClientOrganism;
